import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 1369FF9C-0E57-4644-BE89-7B5EED0131B0
 * name human-male
 * version: 1.6.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/human-male.svg
 * tags
 * - People / Family 
 */
export const HumanMaleIcon = createSvgIcon(<><path d="M12,2A2,2 0 0,1 14,4A2,2 0 0,1 12,6A2,2 0 0,1 10,4A2,2 0 0,1 12,2M10.5,7H13.5A2,2 0 0,1 15.5,9V14.5H14V22H10V14.5H8.5V9A2,2 0 0,1 10.5,7Z" /></>, 'HumanMaleIcon');
export default HumanMaleIcon